import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47f3c09e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_sales_order_add_product_item",
  ref: "addProductItemRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-1280px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header px-9",
  id: "kt_modal_sales_order_add_product_item_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-header border-0 py-5 px-9" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "form-group mb-7" }
const _hoisted_13 = { class: "form-label fw-bold" }
const _hoisted_14 = { class: "el-form-item__content" }
const _hoisted_15 = { class: "col-md-12" }
const _hoisted_16 = { class: "form-group mb-7" }
const _hoisted_17 = { class: "form-label fw-bold" }
const _hoisted_18 = { class: "el-form-item__content d-flex" }
const _hoisted_19 = {
  class: "btn btn-primary w-100 mw-45px h-45px p-0 radius-right",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_qrcode_scanner"
}
const _hoisted_20 = { class: "svg-icon svg-icon-3 m-0" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "svg-icon svg-icon-3 m-0" }
const _hoisted_25 = { class: "col-md-12 d-flex justify-content-end" }
const _hoisted_26 = { class: "svg-icon svg-icon-2" }
const _hoisted_27 = { class: "d-flex align-items-center flex-nowrap w-100" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "svg-icon svg-icon-3 m-0" }
const _hoisted_32 = { class: "svg-icon svg-icon-2" }
const _hoisted_33 = {
  key: 0,
  class: "d-flex gap-3 justify-content-end"
}
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "svg-icon svg-icon-2" }
const _hoisted_36 = {
  class: "menu menu-sub menu-sub-dropdown w-250px w-md-600px",
  "data-kt-menu": "true"
}
const _hoisted_37 = { class: "px-7 py-5" }
const _hoisted_38 = { class: "fs-5 text-dark fw-bolder" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1))
const _hoisted_40 = { class: "px-7 py-5" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-md-6 form-group mb-7" }
const _hoisted_43 = { class: "form-label fw-bold" }
const _hoisted_44 = { class: "col-md-6 form-group mb-7" }
const _hoisted_45 = { class: "form-label fw-bold" }
const _hoisted_46 = { class: "col-md-6 form-group mb-7" }
const _hoisted_47 = { class: "form-label fw-bold" }
const _hoisted_48 = { class: "d-flex justify-content-end" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = ["disabled"]
const _hoisted_51 = { class: "card-body" }
const _hoisted_52 = { class: "modal-body p-0" }
const _hoisted_53 = { class: "d-flex" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["checked", "disabled"]
const _hoisted_56 = { class: "d-flex" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = ["checked", "disabled"]
const _hoisted_59 = { class: "text-line-clamp-1" }
const _hoisted_60 = { class: "d-flex align-items-center max-sm-justify-content-center" }
const _hoisted_61 = { class: "d-flex" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = ["checked", "disabled"]
const _hoisted_64 = { class: "d-flex" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["checked", "disabled"]
const _hoisted_67 = { class: "text-line-clamp-1" }
const _hoisted_68 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_69 = { class: "modal-footer justify-content-end max-sm-justify-content-center py-5 px-9" }
const _hoisted_70 = { class: "d-flex gap-3 justify-content-end max-sm-justify-content-center" }
const _hoisted_71 = { class: "svg-icon svg-icon-3" }
const _hoisted_72 = ["disabled"]
const _hoisted_73 = { class: "indicator-label" }
const _hoisted_74 = { class: "svg-icon svg-icon-3" }
const _hoisted_75 = { class: "indicator-progress" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_window_resize = _resolveComponent("window-resize")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_common_channel_option = _resolveComponent("common-channel-option")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_product_info = _resolveComponent("product-info")!
  const _component_sku_info = _resolveComponent("sku-info")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_empty_data_action = _resolveComponent("empty-data-action")!
  const _component_empty_data = _resolveComponent("empty-data")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_qrcode_scanner = _resolveComponent("qrcode-scanner")!
  const _directive_table = _resolveDirective("table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("salesOrderOverview.addProduct")), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_window_resize, null, {
                  sm: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t("salesOrderOverview.selectBrand")), 1),
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_el_select, {
                              class: "w-100",
                              ref: "selectBrand",
                              onFocus: _ctx.cancelReadonly,
                              "onHook:mounted": _ctx.cancelReadonly,
                              onVisibleChange: _ctx.cancelReadonly,
                              teleported: false,
                              modelValue: _ctx.formData.brand_id,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.brand_id) = $event)),
                              clearable: "",
                              filterable: "",
                              "remote-show-suffix": "",
                              remote: "",
                              "remote-method": _ctx.searchBrandSourceItems,
                              loading: _ctx.options.brandLoading,
                              placeholder: 
                              _ctx.t('common.plsSelect') + _ctx.t('order.brand')
                            
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.brand, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "remote-method", "loading", "placeholder"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.t("salesOrderOverview.searchSku")), 1),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("button", _hoisted_19, [
                              _createElementVNode("span", _hoisted_20, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm010.svg" })
                              ])
                            ]),
                            _createVNode(_component_el_input, {
                              class: "flex-1 border-radius-none",
                              modelValue: _ctx.formData.search_value,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.search_value) = $event)),
                              modelModifiers: { trim: true },
                              type: "text",
                              placeholder: 
                              _ctx.t('salesOrderOverview.searchBySkuMore')
                            
                            }, null, 8, ["modelValue", "placeholder"]),
                            _createElementVNode("button", {
                              class: "btn btn-primary w-100 mw-45px h-45px p-0 border-radius-right",
                              type: "button",
                              disabled: _ctx.isDisabledSearch || _ctx.loading,
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getFormInfo && _ctx.getFormInfo(...args)))
                            }, [
                              _withDirectives(_createElementVNode("span", null, _hoisted_23, 512), [
                                [_vShow, _ctx.loading]
                              ]),
                              _withDirectives(_createElementVNode("span", null, [
                                _createElementVNode("span", _hoisted_24, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
                                ])
                              ], 512), [
                                [_vShow, !_ctx.loading]
                              ])
                            ], 8, _hoisted_21)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary text-nowrap",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#modal_draft_order_overview_add_sku",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showSkuModal && _ctx.showSkuModal(...args)))
                        }, [
                          _createElementVNode("span", _hoisted_26, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.t("salesOrderOverview.newSalesOrderNewProducts")), 1)
                        ])
                      ])
                    ])
                  ]),
                  lg: _withCtx(() => [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_el_select, {
                        class: "w-100 mw-200px border-radius-left",
                        ref: "selectBrand",
                        onFocus: _ctx.cancelReadonly,
                        "onHook:mounted": _ctx.cancelReadonly,
                        onVisibleChange: _ctx.cancelReadonly,
                        teleported: false,
                        modelValue: _ctx.formData.brand_id,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.brand_id) = $event)),
                        clearable: "",
                        filterable: "",
                        "remote-show-suffix": "",
                        remote: "",
                        "remote-method": _ctx.searchBrandSourceItems,
                        loading: _ctx.options.brandLoading,
                        placeholder: _ctx.t('common.plsSelect') + _ctx.t('order.brand')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.brand, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "remote-method", "loading", "placeholder"]),
                      _createVNode(_component_el_input, {
                        class: "mw-475px w-100 border-radius-none bg-transparent",
                        modelValue: _ctx.formData.search_value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.search_value) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: _ctx.t('salesOrderOverview.searchBySkuMore')
                      }, null, 8, ["modelValue", "placeholder"]),
                      _createElementVNode("button", {
                        class: "btn btn-primary w-100 mw-45px h-45px p-0 border-radius-right",
                        type: "button",
                        disabled: _ctx.isDisabledSearch || _ctx.loading,
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.getFormInfo && _ctx.getFormInfo(...args)))
                      }, [
                        _withDirectives(_createElementVNode("span", null, _hoisted_30, 512), [
                          [_vShow, _ctx.loading]
                        ]),
                        _withDirectives(_createElementVNode("span", null, [
                          _createElementVNode("span", _hoisted_31, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
                          ])
                        ], 512), [
                          [_vShow, !_ctx.loading]
                        ])
                      ], 8, _hoisted_28),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary text-nowrap ms-6",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#modal_draft_order_overview_add_sku",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.showSkuModal && _ctx.showSkuModal(...args)))
                      }, [
                        _createElementVNode("span", _hoisted_32, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.t("salesOrderOverview.newSalesOrderNewProducts")), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }),
                (0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-light-primary me-3",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        disabled: _ctx.loading
                      }, [
                        _createElementVNode("span", _hoisted_35, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.filter")), 1)
                      ], 8, _hoisted_34),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.t("common.filterOptions")), 1)
                        ]),
                        _hoisted_39,
                        _createElementVNode("div", _hoisted_40, [
                          _createVNode(_component_el_form, {
                            ref: "formRef",
                            model: _ctx.formData
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, [
                                  _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.t("order.merchant")) + ":", 1),
                                  _withDirectives(_createVNode(_component_el_form_item, { prop: "brand_id" }, null, 512), [
                                    [_vShow, 0]
                                  ]),
                                  _withDirectives(_createVNode(_component_el_form_item, { prop: "search_value" }, null, 512), [
                                    [_vShow, 0]
                                  ]),
                                  _withDirectives(_createVNode(_component_el_form_item, { prop: "items" }, null, 512), [
                                    [_vShow, 0]
                                  ]),
                                  _withDirectives(_createVNode(_component_el_form_item, { prop: "currentPage" }, null, 512), [
                                    [_vShow, 0]
                                  ]),
                                  _withDirectives(_createVNode(_component_el_form_item, { prop: "pageSize" }, null, 512), [
                                    [_vShow, 0]
                                  ]),
                                  _withDirectives(_createVNode(_component_el_form_item, { prop: "total" }, null, 512), [
                                    [_vShow, 0]
                                  ]),
                                  _withDirectives(_createVNode(_component_el_form_item, { prop: "sku_ids" }, null, 512), [
                                    [_vShow, 0]
                                  ]),
                                  _withDirectives(_createVNode(_component_el_form_item, { prop: "products" }, null, 512), [
                                    [_vShow, 0]
                                  ]),
                                  _createVNode(_component_el_form_item, { prop: "merchant_id" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        class: "w-100",
                                        ref: "selectMerchant",
                                        onFocus: _ctx.cancelReadonly,
                                        "onHook:mounted": _ctx.cancelReadonly,
                                        onVisibleChange: _ctx.cancelReadonly,
                                        teleported: false,
                                        modelValue: _ctx.formData.merchant_id,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.merchant_id) = $event)),
                                        filterable: "",
                                        clearable: "",
                                        "remote-show-suffix": "",
                                        remote: "",
                                        "remote-method": _ctx.searchMerchantSourceItems,
                                        loading: _ctx.options.merchantLoading,
                                        placeholder: _ctx.t('common.plsSelect'),
                                        onChange: _ctx.getSalesChannelsData
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchant, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.value,
                                              label: item.label,
                                              value: item.value
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "remote-method", "loading", "placeholder", "onChange"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.t("inventory.inventoryType")) + ":", 1),
                                  _createVNode(_component_el_form_item, { prop: "inventory_type" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        class: "w-100",
                                        modelValue: _ctx.formData.inventory_type,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.inventory_type) = $event)),
                                        clearable: "",
                                        placeholder: _ctx.t('common.plsSelect')
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: "非现货",
                                            value: ""
                                          }),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.inventory_type, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.value,
                                              label: item.label,
                                              value: item.value
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "placeholder"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_46, [
                                  _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.t("order.channel")) + ":", 1),
                                  _createVNode(_component_el_form_item, { prop: "channel_id" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        class: "w-100",
                                        modelValue: _ctx.formData.channel_id,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.channel_id) = $event)),
                                        clearable: "",
                                        loading: _ctx.options.channelLoading,
                                        placeholder: _ctx.t('common.plsSelect')
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.channel, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.value,
                                              label: item.label,
                                              value: item.value
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_common_channel_option, { channelOption: item }, null, 8, ["channelOption"])
                                              ]),
                                              _: 2
                                            }, 1032, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "loading", "placeholder"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("button", {
                                  type: "reset",
                                  class: "btn btn-sm btn-light btn-active-light-primary me-2",
                                  "data-kt-menu-dismiss": "true",
                                  disabled: _ctx.isDisabledSearch || _ctx.loading,
                                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleReset && _ctx.handleReset(...args)))
                                }, _toDisplayString(_ctx.t("common.reset")), 9, _hoisted_49),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm btn-primary",
                                  "data-kt-menu-dismiss": "true",
                                  disabled: _ctx.isDisabledSearch || _ctx.loading,
                                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleFilter && _ctx.handleFilter(...args)))
                                }, _toDisplayString(_ctx.t("common.apply")), 9, _hoisted_50)
                              ])
                            ]),
                            _: 1
                          }, 8, ["model"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(_component_window_resize, null, {
                    sm: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                        class: "mb-7 w-100",
                        ref: "multipleTableRef",
                        data: _ctx.formData.items,
                        onSelect: _ctx.handleSelectChange,
                        onSelectionChange: _ctx.handleSelectionChange
                      }, {
                        empty: _withCtx(() => [
                          (
                            _ctx.options.isRequest &&
                            (_ctx.formData.brand_id !== '' ||
                              _ctx.formData.search_value !== '')
                          )
                            ? (_openBlock(), _createBlock(_component_empty_data_action, {
                                key: 0,
                                img: "media/icons/duotune/general/gen004.svg",
                                "img-class": "svg-icon-5x",
                                title: _ctx.$t('salesOrderOverview.noResultsFound'),
                                "sub-title": 
                            _ctx.$t('salesOrderOverview.noResultsFoundTip')
                          ,
                                "action-modal": "modal_draft_order_overview_add_sku",
                                "action-icon": "media/icons/duotune/arrows/arr075.svg",
                                "action-label": 
                            _ctx.$t('salesOrderOverview.newSalesOrderNewProducts')
                          ,
                                onActionClick: _ctx.showSkuModal
                              }, null, 8, ["title", "sub-title", "action-label", "onActionClick"]))
                            : (_openBlock(), _createBlock(_component_empty_data, { key: 1 }))
                        ]),
                        default: _withCtx(() => [
                          (_ctx.isRaido)
                            ? (_openBlock(), _createBlock(_component_el_table_column, {
                                key: 0,
                                label: "",
                                width: "50",
                                fixed: "left"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createElementVNode("div", _hoisted_53, [
                                    _createElementVNode("label", {
                                      class: _normalizeClass(["form-check form-check-sm form-check-custom form-check-solid", {
                                'cursor-nodrop': !_ctx.isSelectable(row) || _ctx.loading,
                              }]),
                                      onClick: _withModifiers(($event: any) => (_ctx.toggleItemSelect(row)), ["stop"])
                                    }, [
                                      _createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "radio",
                                        name: "choose_bound_product_item",
                                        checked: _ctx.isChecked(row),
                                        disabled: !_ctx.isSelectable(row) || _ctx.loading
                                      }, null, 8, _hoisted_55)
                                    ], 10, _hoisted_54)
                                  ])
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_el_table_column, {
                                key: 1,
                                label: "",
                                width: "50"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createElementVNode("div", _hoisted_56, [
                                    _createElementVNode("label", {
                                      class: _normalizeClass(["form-check form-check-sm form-check-custom form-check-solid", {
                                'cursor-nodrop': !_ctx.isSelectable(row) || _ctx.loading,
                              }]),
                                      onClick: _withModifiers(($event: any) => (_ctx.toggleItemSelect(row)), ["stop"])
                                    }, [
                                      _createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        checked: _ctx.isChecked(row),
                                        disabled: !_ctx.isSelectable(row) || _ctx.loading
                                      }, null, 8, _hoisted_58)
                                    ], 10, _hoisted_57)
                                  ])
                                ]),
                                _: 1
                              })),
                          _createVNode(_component_el_table_column, {
                            label: _ctx.t('order.product'),
                            "min-width": "100"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createVNode(_component_product_info, {
                                gallery: _ctx.getSkuListItemImages(row),
                                brand_id: row.brand_name,
                                source_link: '',
                                name: row.name,
                                name_en: row.name_en
                              }, null, 8, ["gallery", "brand_id", "name", "name_en"])
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            label: _ctx.t('order.sku')
                          }, {
                            default: _withCtx(({ row }) => [
                              _createVNode(_component_sku_info, {
                                brand_article_no: row.brand_article_no,
                                merchant_article_no: row.merchant_article_no,
                                product_identifier_id: '0',
                                color: row.color_name,
                                "normal-color": row.normal_color,
                                size: row.size_name,
                                "max-width": "300px"
                              }, null, 8, ["brand_article_no", "merchant_article_no", "color", "normal-color", "size"])
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            label: _ctx.t('order.skuNo'),
                            prop: "sku"
                          }, null, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            label: _ctx.t('orderRequest.merchantVendor'),
                            "min-width": "100"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createVNode(_component_el_popover, {
                                placement: "top",
                                width: "auto",
                                trigger: "hover"
                              }, {
                                reference: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.CommonArrayToString(row.merchant_name)), 1)
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, _toDisplayString(_ctx.CommonArrayToString(row.merchant_name)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            label: _ctx.t('salesOrderOverview.customizeChannel'),
                            "min-width": "190"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createTextVNode(_toDisplayString(row.merchant_channel_name), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            label: _ctx.t('order.quantity'),
                            align: "right",
                            "min-width": "120"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createTextVNode(_toDisplayString(row.qty), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            label: _ctx.t('order.price'),
                            align: "right"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createTextVNode(_toDisplayString(_ctx.$currency.currency(row.price, 2, ",", ".", "€ ")), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }, 8, ["data", "onSelect", "onSelectionChange"])), [
                        [_directive_table]
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createVNode(_component_el_pagination, {
                          "current-page": _ctx.formData.currentPage,
                          "onUpdate:current-page": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.currentPage) = $event)),
                          onCurrentChange: _ctx.currentPageChange,
                          "page-size": _ctx.formData.pageSize,
                          "pager-count": 5,
                          layout: "prev, pager, next",
                          total: _ctx.formData.total,
                          "hide-on-single-page": true,
                          background: ""
                        }, null, 8, ["current-page", "onCurrentChange", "page-size", "total"])
                      ])
                    ]),
                    lg: _withCtx(() => [
                      _createVNode(_component_el_table, {
                        class: "mb-7 w-100",
                        ref: "multipleTableRef",
                        data: _ctx.formData.items,
                        onSelect: _ctx.handleSelectChange,
                        onSelectionChange: _ctx.handleSelectionChange
                      }, {
                        empty: _withCtx(() => [
                          (
                            _ctx.options.isRequest &&
                            (_ctx.formData.brand_id !== '' ||
                              _ctx.formData.search_value !== '')
                          )
                            ? (_openBlock(), _createBlock(_component_empty_data_action, {
                                key: 0,
                                img: "media/icons/duotune/general/gen004.svg",
                                "img-class": "svg-icon-5x",
                                title: _ctx.$t('salesOrderOverview.noResultsFound'),
                                "sub-title": 
                            _ctx.$t('salesOrderOverview.noResultsFoundTip')
                          ,
                                "action-modal": "modal_draft_order_overview_add_sku",
                                "action-icon": "media/icons/duotune/arrows/arr075.svg",
                                "action-label": 
                            _ctx.$t('salesOrderOverview.newSalesOrderNewProducts')
                          ,
                                onActionClick: _ctx.showSkuModal
                              }, null, 8, ["title", "sub-title", "action-label", "onActionClick"]))
                            : (_openBlock(), _createBlock(_component_empty_data, { key: 1 }))
                        ]),
                        default: _withCtx(() => [
                          (_ctx.isRaido)
                            ? (_openBlock(), _createBlock(_component_el_table_column, {
                                key: 0,
                                label: "",
                                width: "50",
                                fixed: "left"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createElementVNode("div", _hoisted_61, [
                                    _createElementVNode("label", {
                                      class: _normalizeClass(["form-check form-check-sm form-check-custom form-check-solid", {
                                'cursor-nodrop': !_ctx.isSelectable(row) || _ctx.loading,
                              }]),
                                      onClick: _withModifiers(($event: any) => (_ctx.toggleItemSelect(row)), ["stop"])
                                    }, [
                                      _createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "radio",
                                        name: "choose_bound_product_item",
                                        checked: _ctx.isChecked(row),
                                        disabled: !_ctx.isSelectable(row) || _ctx.loading
                                      }, null, 8, _hoisted_63)
                                    ], 10, _hoisted_62)
                                  ])
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_el_table_column, {
                                key: 1,
                                label: "",
                                width: "50"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createElementVNode("div", _hoisted_64, [
                                    _createElementVNode("label", {
                                      class: _normalizeClass(["form-check form-check-sm form-check-custom form-check-solid", {
                                'cursor-nodrop': !_ctx.isSelectable(row) || _ctx.loading,
                              }]),
                                      onClick: _withModifiers(($event: any) => (_ctx.toggleItemSelect(row)), ["stop"])
                                    }, [
                                      _createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        checked: _ctx.isChecked(row),
                                        disabled: !_ctx.isSelectable(row) || _ctx.loading
                                      }, null, 8, _hoisted_66)
                                    ], 10, _hoisted_65)
                                  ])
                                ]),
                                _: 1
                              })),
                          _createVNode(_component_el_table_column, {
                            label: _ctx.t('order.product'),
                            width: "200"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createVNode(_component_product_info, {
                                gallery: _ctx.getSkuListItemImages(row),
                                brand_id: row.brand_name,
                                source_link: '',
                                name: row.name,
                                name_en: row.name_en
                              }, null, 8, ["gallery", "brand_id", "name", "name_en"])
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            label: _ctx.t('order.sku'),
                            width: "auto",
                            "min-width": "400"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createVNode(_component_sku_info, {
                                brand_article_no: row.brand_article_no,
                                merchant_article_no: row.merchant_article_no,
                                product_identifier_id: '0',
                                color: row.color_name,
                                "normal-color": row.normal_color,
                                size: row.size_name,
                                "max-width": "300px"
                              }, null, 8, ["brand_article_no", "merchant_article_no", "color", "normal-color", "size"])
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            label: _ctx.t('order.skuNo'),
                            prop: "sku"
                          }, null, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            label: _ctx.t('orderRequest.merchantVendor')
                          }, {
                            default: _withCtx(({ row }) => [
                              _createVNode(_component_el_popover, {
                                placement: "top",
                                width: "auto",
                                trigger: "hover"
                              }, {
                                reference: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.CommonArrayToString(row.merchant_name)), 1)
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, _toDisplayString(_ctx.CommonArrayToString(row.merchant_name)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            label: _ctx.t('salesOrderOverview.customizeChannel')
                          }, {
                            default: _withCtx(({ row }) => [
                              _createTextVNode(_toDisplayString(row.merchant_channel_name), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            label: _ctx.t('order.quantity'),
                            align: "right"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createTextVNode(_toDisplayString(row.qty), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_table_column, {
                            label: _ctx.t('order.price'),
                            align: "right"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createTextVNode(_toDisplayString(_ctx.$currency.currency(row.price, 2, ",", ".", "€ ")), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }, 8, ["data", "onSelect", "onSelectionChange"]),
                      _createElementVNode("div", _hoisted_68, [
                        _createVNode(_component_el_pagination, {
                          "current-page": _ctx.formData.currentPage,
                          "onUpdate:current-page": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.currentPage) = $event)),
                          onCurrentChange: _ctx.currentPageChange,
                          "page-size": _ctx.formData.pageSize,
                          layout: "prev, pager, next",
                          total: _ctx.formData.total,
                          "hide-on-single-page": true,
                          background: ""
                        }, null, 8, ["current-page", "onCurrentChange", "page-size", "total"])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])), [
                [_directive_loading, _ctx.loading]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-light",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)))
              }, [
                _createElementVNode("span", _hoisted_71, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("salesOrderOverview.stepcancel")), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-lg btn-primary",
                disabled: _ctx.isDisabledSubmit,
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, [
                _createElementVNode("span", _hoisted_73, [
                  _createElementVNode("span", _hoisted_74, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("salesOrderOverview.addProducts")), 1)
                ]),
                _createElementVNode("span", _hoisted_75, [
                  _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                  _hoisted_76
                ])
              ], 8, _hoisted_72)
            ])
          ])
        ])
      ])
    ], 512),
    _createVNode(_component_qrcode_scanner, { onUpdateList: _ctx.scanResult }, null, 8, ["onUpdateList"])
  ], 64))
}